"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";

const ROW_COUNT = 3;

export const NotificationBellDropdownSkeleton = () => (
  <Box px={3} py={2}>
    {Array.from({ length: ROW_COUNT }).map((_, index) => (
      <Box
        key={index}
        px={2}
        py={2.5}
        mb={index < ROW_COUNT - 1 ? 1 : 0}
        borderRadius="6px"
      >
        <Flex justify="space-between" align="flex-start" gap={2} mb={1.5}>
          <Skeleton height="14px" width={`${55 + index * 12}%`} borderRadius="4px" />
          <Skeleton boxSize="8px" borderRadius="full" flexShrink={0} mt={0.5} />
        </Flex>
        <Skeleton height="12px" width="100%" mb={1} borderRadius="4px" />
        <Skeleton height="12px" width="78%" mb={2} borderRadius="4px" />
        <Flex justify="space-between" align="center">
          <Skeleton height="10px" width="48px" borderRadius="4px" />
          <Skeleton height="10px" width="72px" borderRadius="4px" />
        </Flex>
      </Box>
    ))}
  </Box>
);
